(function ($) {


    $(document).ready(function () {
        dailogWindowAddAriaLabel();
        removeBackdropforLinks();
    });

    function removeBackdropforLinks() {
        $('[data-bs-toggle="modal"]').each(function () {
            if (!$(this).hasClass('b05-button')) {
                var targetid = $(this).attr('data-bs-target');
                $(targetid).removeAttr('data-bs-backdrop');
            }
        });
    }

    // added for Dialog window is announced with its label - accessibility
    function dailogWindowAddAriaLabel() {
        var formElement = $('.modal.fade').find("form");
        if ($(formElement).length > 0) {
            $(formElement).each(function (index) {
                var headingElement = $(this).find(":header");
                if ($(headingElement).length > 0) {
                    var firstHeadingElement = headingElement[0];
                    var headingText = $(firstHeadingElement).text().replace(/ /g, '');
                    headingText = headingText + index;
                    if (!$(headingElement[0]).attr('id')) {
                        $(headingElement[0]).attr('id', headingText);
                        $(this).closest('.modal.fade').attr('aria-labelledby', headingText);
                    } else {
                        $(this).closest('.modal.fade').attr('aria-labelledby', $(headingElement[0]).attr('id'));
                    }
                }
            });
        }
    }

    $('body')
        .on('show.bs.modal', '.modal', onModalShow)
        .on('hide.bs.modal', onModalHide)
        .on('shown.bs.modal', onModalShown);
    var focusElement;
    function onModalShow(e) {
        // FLWEP2-4431 Audit Issue 1.23 The focus leaves the dialog window before it is closed.
        $(".body-wrapper").attr("aria-hidden", "true");
        focusElement = document.activeElement;
        var modal = $(e.target);
        for (var i = 0; i < $('.modal.fade').length; i++) {
            if (focusElement.dataset.target !== modal.attr('id')) {
                var ele = $('.modal.fade')[i];
                ele.setAttribute("aria-hidden", "true");
            } else {
                var ele1 = $('.modal.fade.show')[i];
                ele1.setAttribute("aria-hidden", "false");
            }
        }
        enableNestedModals(modal);
        if (modal.is('.modal-iframe')) {
            setIframeSrc(modal);
        }
        if (!modal.is('[data-suppress-move="true"]')) {
            ensureModalIsFormChild(modal);
        }
    }

    function onModalShown(e) {
        focusElement = document.activeElement;
        var modal = $(e.target);
        if (modal.find('.sitecore-form').length > 0) {
            modal.find('.form-area .form-group:first-of-type label+input').focus();
        }
        if ($("#ddlCountry:visible").length) {
            $.ajax({
                url: $("#URLEndpointName").val(),
                type: 'POST',
                async: false,
                data: {
                    countryIso: $("#ddlCountry").val(),
                    productName: $("#hdnProduct").val()
                },
                dataType: "html",
                success: function (data) {

                    $("#divPartialView").html(sanitizeHtmlStrings(data));

                    if (data.length <= 54)
                        $("#ResultsNotFound").show();
                    else
                        $("#ResultsNotFound").hide();
                },
                failure: function (msg) {
                }
            });
        }
        //  var iframeSrc1 = $(e.target).siblings();
        //  var iframeEle1 = $(iframeSrc1).children('iframe');
        //  var videosrc = $(iframeEle1).attr('data-original-src');
        //  $(iframeEle1).attr('src', videosrc);
    }

    function onModalHide(e) {
        // FLWEP2-4431 Audit Issue 1.23 The focus leaves the dialog window before it is closed.
        if (!$(document.activeElement).parents().hasClass('modal-dialog')) {
            attachEventHandler("modalOutsideClick", "backdropClick", true);
        }
        $(".body-wrapper").attr("aria-hidden", "false");
        var focusElement1 = document.activeElement;
        var modal = $(e.target);
        for (var i = 0; i < $('.modal.fade').length; i++) {
            var ele = $('.modal.fade')[i];
            ele.setAttribute("aria-hidden", "false");
        }
        resetForm(modal);
        setTimeout(function () { focusElement.focus(); }, 1000);
        var iframeSrc = $(e.target).siblings();
        var iframeEle = $(iframeSrc).children('iframe');
        if ($(iframeEle).attr('allow') === 'autoplay') {
            $(iframeEle).attr('src', '');
        } else {
            $(iframeEle).attr('src', $(iframeSrc).children('iframe').attr('src'));
        }
    }

    function enableNestedModals(modal) {
        if ($('.modal:visible').length > 1) {
            var zIndex = 1040 + (10 * $('.modal:visible').length);
            modal.css('z-index', zIndex);
            setTimeout(function () {
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
            }, 0);
        }
    }

    function ensureModalIsFormChild(modal) {
        if (!modal.parent().is('body')) modal.appendTo('body');
    }

    function setIframeSrc(modal) {
        var src = modal.data('iframeSrc');
        var iframe = modal.find('iframe');
        if (!iframe.length || !src) return;
        iframe.attr('src', src);
    }

    function resetForm(modal) {
        var $modalForms = modal.find('form');
        if (!$modalForms.length) return;
        $modalForms.each(function (i, form) {
            form.reset();
            $(form).removeAttr('data-xss-checked');
        });
        $(".field-validation-valid").text('');
    }


    $(".modal-body select").focus(function () {
        if (/iPad/.test(navigator.userAgent) && !window.MSStream) {
            $(".modal-body select").each(function () {
                $(this).change(function () {
                    $(this).focus();
                });
            });
        }
    });

    $(function () {
        $('.gallery-video-modal .btn-close').click(function (e) {
            var iframeSrc = $(e.target).siblings();
            var iframeEle = $(iframeSrc).children('iframe');
            if ($(iframeEle).attr('allow') === 'autoplay') {
                $(iframeEle).attr('src', '');
            } else {
                $(iframeEle).attr('src', $(iframeSrc).children('iframe').attr('src'));
            }



        });
    });
    $("#lightbox-pdsdatasheet, #lightbox-sdsdatasheet").on(
        "shown.bs.modal",
        function (e) {
            var modal = $(e.target);
            setTimeout(function () {
                if (modal.find("select").length > 0) {
                    modal.find("select")[0].focus();
                } else {
                    modal.find(".btn-cancel").focus();
                }
            }, 200);
        }
    );

    $(document).ready(function () {
        var pdsShareLinkClicked = false;
        var pdsflag, flagSDS, flagPDS = false;


        $(document).on('click', '#shareform01 .btn-close,#shareform01 .btn-cancel', function (event) {
            if (pdsflag) {
                $('#shareform01').modal('hide'); // Close the form modal
                pdsShareLinkClicked = false; // Set to false since the form is closed
                $('#downloadpdsid, #downloadpds').modal('show');// Ensure the share link modal remains visible
            }
            if (flagSDS) {
                $('#shareform01').modal('hide'); // Close the form modal
                pdsShareLinkClicked = false; // Set to false since the form is closed
                $('#lightbox-sdsdatasheet').modal('show');// Ensure the share link modal remains visible
            }
            if (flagPDS) {
                $('#shareform01').modal('hide'); // Close the form modal
                pdsShareLinkClicked = false; // Set to false since the form is closed
                $('#lightbox-pdsdatasheet').modal('show');// Ensure the share link modal remains visible
            }

        });

        // Event for share link modal close button (#downloadpdsid)
        $(document).on('click', '#downloadpdsid .btn-close, #downloadpds .btn-close, #downloadpdsid .btn-cancel, #downloadpds .btn-cancel', function (event) {
            $('#downloadpdsid, #downloadpds').modal('hide'); // Close the share link modal
            pdsShareLinkClicked = false;
            pdsflag = false;// Reset the flag when the share link modal is closed
        });

        $(document).on('click', '#lightbox-sdsdatasheet .btn-close, #lightbox-sdsdatasheet .btn-cancel', function (event) {
            $('#lightbox-sdsdatasheet').modal('hide'); // Close the share link modal
            pdsShareLinkClicked = false;
            flagSDS = false;// Reset the flag when the share link modal is closed
        });

        $(document).on('click', '#lightbox-pdsdatasheet .btn-close, #lightbox-pdsdatasheet .btn-cancel', function (event) {
            $('#lightbox-pdsdatasheet').modal('hide'); // Close the share link modal
            pdsShareLinkClicked = false;
            flagPDS = false;// Reset the flag when the share link modal is closed
        });


        // Event for share link click
        $(document).on('click', '.pds-share-link', function (event) {
            pdsShareLinkClicked = true; // Set the flag when a share link is clicked
            $('#shareform01').modal('show'); // Open the share form modal
            $('#downloadpdsid, #downloadpds').modal('show');
            if ($(event.currentTarget).hasClass("pds-share-link")) {
                pdsflag = true; // Ensure the share link modal remains visible
            }
            if (($(event.currentTarget).closest("#lightbox-sdsdatasheet").length > 0) && ($(event.currentTarget).hasClass("pds-share-link"))) {
                flagSDS = true;
            }
            if (($(event.currentTarget).closest("#lightbox-pdsdatasheet").length > 0) && ($(event.currentTarget).hasClass("pds-share-link"))) {
                flagPDS = true; // Ensure the share link modal remains visible
            }
        });

        // Event for share link modal hide
        $(document).on('hidden.bs.modal', '#downloadpdsid, #downloadpds', function () {
            pdsShareLinkClicked = false; // Ensure the flag resets when the share link modal is closed            
        });
        var preventReopenPDS = false;
        var preventReopenSDS = false;

        // Track backdrop click for the PDS modal
        $('#lightbox-pdsdatasheet').on('hide.bs.modal', function (event) {
            if ($(event.target).is($(this))) {
                preventReopenPDS = true; // Backdrop click
            }
        });

        // Track backdrop click for the SDS modal
        $('#lightbox-sdsdatasheet').on('hide.bs.modal', function (event) {
            if ($(event.target).is($(this))) {
                preventReopenSDS = true; // Backdrop click
            }
        });

        // Reset prevent flags when clicking inside the modal
        $('#lightbox-pdsdatasheet').on('click', '.modal-content', function () {
            preventReopenPDS = false; // Allow reopening since user clicked inside
        });

        $('#lightbox-sdsdatasheet').on('click', '.modal-content', function () {
            preventReopenSDS = false; // Allow reopening since user clicked inside
        });

        // Handle PDS modal hidden event
        $(document).on('hidden.bs.modal', '#lightbox-pdsdatasheet', function () {
            if (!preventReopenPDS && flagPDS && $("#shareform01").length === 0) {
                $('#lightbox-pdsdatasheet').modal('show').addClass('show');
            } else {
                preventReopenPDS = false; // Reset the flag
            }
        });

        // Handle SDS modal hidden event
        $(document).on('hidden.bs.modal', '#lightbox-sdsdatasheet', function () {
            if (!preventReopenSDS && flagSDS && $("#shareform01").length === 0) {
                $('#lightbox-sdsdatasheet').modal('show').addClass('show');
            } else {
                preventReopenSDS = false; // Reset the flag
            }
        });

    });


}(window.jQuery));



/*Analytics*/
analytics.eventConfig.push(
    {
        "target": "*",
        "codeId": "c04",
        "events": [
            {
                "eventTarget": ":not(.form-submit)[data-bs-toggle*=modal], .product-locator search-results [data-bs-toggle*=modal], .product-locator-ff search-results [data-bs-toggle*=modal]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "lightbox",
                    "componentId": "c04",
                    "eventType": "lightbox load click",
                    "elementType": [
                        {
                            "rule": "$(context).hasClass('btn')",
                            "value": "lightbox button"
                        },
                        {
                            "rule": "true",
                            "value": "lightbox link"
                        }
                    ],
                    "elementText": "",
                    "destinationUrl": "",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }
        ]
    },
    {
        "target": ".modal-dialog",
        "codeId": "c04",
        "events": [
            {
                "eventTarget": "button.btn.btn-cancel",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "titleText": "",
                    "componentName": "lightbox",
                    "componentId": "c04",
                    "eventType": "lightbox cancel click",
                    "elementText": "",
                    "destinationUrl": "",
                    "elementType": "cancel link",
                    "parentName": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".modal-content button.btn-close span",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "lightbox",
                    "componentId": "c04",
                    "eventType": "lightbox exit click",
                    "elementType": "x out icon",
                    "titleText": "",
                    "parentName": "",
                    "parentTitle": ""
                }
            }
        ]
    },
    {
        "target": ".cardListModal_container",
        "codeId": "C04",
        "events": [
            {
                "eventTarget": ".cardListModal_container__child a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "c04",
                    "componentName": "lightbox",
                    "elementText": "",
                    "destinationUrl": "",
                    "event": "navigation",
                    "eventType": "lightbox load click",
                    "elementType": "lightbox link",
                    "eventLabel": "",
                    "fileName": "",
                    "parentName": "Card List Modal collection",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            // need to check if this is needed
            {
                "eventTarget": ".cardListModal_container__child.cardListModal_link a[href^=http]",
                "eventType": "click",
                "tags": {
                    "event": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "outbound"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "lightbox load outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "lightbox load internal navigation click"
                        }
                    ],

                    "componentName": "lightbox",
                    "componentId": "c04",
                    "elementType": "lightbox link",
                    "elementText": "",
                    "eventLabel": "",
                    "fileName": "",
                    "destinationUrl": "",
                    "parentName": "Card List Modal collection",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            // clicking the close icon
            {
                "eventTarget": ".cardListModal__popup .close",
                "eventType": "click",
                "tags": {
                    "componentId": "c04",
                    "componentName": "lightbox",
                    "elementText": "",
                    "destinationUrl": "",
                    "event": "navigation",
                    "eventType": "lightbox exit click",
                    "elementType": "x out icon",
                    "fileName": "",
                    "parentName": "Card List Modal collection",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
        ]
    },
    {
        "target": ".cardListModal__popup",
        "codeId": "C04",
        "events": [
            {
                "eventTarget": "backdropClick",
                "eventType": "click",
                "tags": {
                    "componentId": "c04",
                    "componentName": "lightbox",
                    "elementText": "",
                    "destinationUrl": "",
                    "event": "navigation",
                    "eventType": "lightbox exit click",
                    "elementType": "outside click",
                    "fileName": "",
                    "parentName": "Card List Modal collection",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
        ]
    },
    {
        "target": "modalOutsideClick",
        "codeId": "C04",
        "events": [
            {
                "eventTarget": "backdropClick",
                "eventType": "click",
                "tags": {
                    "componentId": "c04",
                    "componentName": "lightbox",
                    "elementText": "",
                    "destinationUrl": "",
                    "event": "navigation",
                    "eventType": "lightbox exit click",
                    "elementType": "lightbox outside click",
                    "fileName": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
        ]
    },

)